import { AppEnvConfig } from "@app/types/root-state/appEnvConfig"

export enum AppEnvConfigAction {
    SetAppEnvConfigData = "appenvconfig:set-app-env-config-data",
}

interface SetAppConfigDataReturn {
    type: AppEnvConfigAction.SetAppEnvConfigData
    payload: AppEnvConfig
}
export const setAppConfigData = (payload: AppEnvConfig): SetAppConfigDataReturn => {
    return {
        type: AppEnvConfigAction.SetAppEnvConfigData,
        payload,
    }
}

export type AnyAppEnvCreator = SetAppConfigDataReturn
